module.exports = __webpack_public_path__ + "assets/img/welcome_4.285d4137.png";